import $ from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'

const CLASS_NAME_ATTR = 'data-react-class'
const PROPS_ATTR = 'data-react-props'
const SELECTOR = `[${CLASS_NAME_ATTR}]`

const findDOMNodes = (searchSelector) => {
  if (typeof searchSelector === 'string') {
    return $(`${searchSelector}${SELECTOR}, ${searchSelector} ${SELECTOR}`, document)
  }

  return $(SELECTOR, searchSelector || document)
}

const getConstructor = (className) => {
  const constructor = className.split('.').reduce((scope, key) => scope && scope[key], window)

  return constructor && constructor.default ? constructor.default : constructor
}

export const mountComponents = (searchSelector) => {
  const nodes = findDOMNodes(searchSelector)

  for (let i = 0; i < nodes.length; ++i) {
    const node = nodes[i]
    const className = node.getAttribute(CLASS_NAME_ATTR)
    const constructor = getConstructor(className)
    const propsJson = node.getAttribute(PROPS_ATTR)
    const props = propsJson && JSON.parse(propsJson)

    if (typeof constructor === 'undefined') {
      throw new Error(`Cannot find component: '${className}'. Make sure your component is globally available to render.`)
    }

    ReactDOM.render(React.createElement(constructor, props), node)
  }
}

export const unmountComponents = (searchSelector) => {
  const nodes = findDOMNodes(searchSelector)

  for (let i = 0; i < nodes.length; ++i) {
    ReactDOM.unmountComponentAtNode(nodes[i])
  }
}
